import { Stack, styled } from '@mui/material'
import { useAtomValue } from 'jotai'
import { memo } from 'react'
import { Ether, TokenSymbol } from 'types'
import { BaseCurrencyInput } from './BaseCurrency'
import { selectedCurrencyAtom } from './CurrencySelection'
import { MinimumSizeCheck } from './MinimumSizeCheck'
import { QuoteCurrencyInput } from './QuoteCurrency'

export const DualModeInputWrap = styled(Stack)`
  position: relative;
`

export const PlaceOrderDualModeAmountInput = memo<{
  currentBaseAmount: Ether
  currentQuoteAmount: Ether
  baseCurrency: TokenSymbol
  quoteCurrency: TokenSymbol
  minimumIncrement: Ether
  onChangeBaseAmount: (amount: Ether) => void
  onChangeQuoteAmount: (amount: Ether) => void
  onClickMax: () => void
}>(
  ({
    currentBaseAmount,
    currentQuoteAmount,
    baseCurrency,
    quoteCurrency,
    minimumIncrement,
    onChangeBaseAmount,
    onChangeQuoteAmount,
    onClickMax,
  }) => {
    const currentCurrency = useAtomValue(selectedCurrencyAtom) ?? baseCurrency

    return (
      <>
        <DualModeInputWrap>
          {currentCurrency === quoteCurrency ? (
            <QuoteCurrencyInput
              currentAmount={currentQuoteAmount}
              baseCurrency={baseCurrency}
              quoteCurrency={quoteCurrency}
              onChangeAmount={onChangeQuoteAmount}
              onClickMax={onClickMax}
            />
          ) : (
            <BaseCurrencyInput
              currentAmount={currentBaseAmount}
              baseCurrency={baseCurrency}
              quoteCurrency={quoteCurrency}
              minimumIncrement={minimumIncrement}
              onChangeAmount={onChangeBaseAmount}
              onClickMax={onClickMax}
            />
          )}
        </DualModeInputWrap>

        <MinimumSizeCheck
          currentAmount={currentBaseAmount}
          baseCurrency={baseCurrency}
          minimumSize={minimumIncrement}
        />
      </>
    )
  },
)
